import React, {useContext, useState} from 'react';
import moment from 'moment';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField
} from '@mui/material';
import {ApplicationContext} from '../../context/ApplicationContext';
import {AddOutlined, FlashOnOutlined} from '@mui/icons-material';
import {submitCreateEntry} from '../../services/entry.service';

const CreateEntryDialog = (props) => {
    const AppContext = useContext(ApplicationContext);
    const [open, setOpen] = React.useState(false);
    const [entryDate, setEntryDate] = useState(moment().format('YYYY-MM-DD'));
    const [entryAmount, setEntryAmount] = useState('');
    const [entryComments, setEntryComments] = useState('');

    const handleClickOpen = () => {
        props.isRapidCreate && props.newestEntryDetails ? submitForm(null, props.newestEntryDetails.amount) : setOpen(true);
    }

    const handleClose = () => setOpen(false);

    const submitForm = (e, rapidCreateAmount) => { // Where 'e' is event
        submitCreateEntry({
            source_key: props.sourceKey,
            entry_date: entryDate,
            amount: rapidCreateAmount || Number(entryAmount.replace(",","")),
            comments: entryComments
        })
            .then((reply) => {
                AppContext.handleNotification('Entry created successfully.');
                props.updateLastFetched();
                handleClose();
            })
            .catch((err) => {
                AppContext.handleError('Unable to create entry.');
            })
    }

    return (<div>
        <IconButton
            onClick={handleClickOpen}
            style={{backgroundColor: 'rgba(99, 102, 241, 0.1)', color: '#6366f1', float: 'right', padding: '12px', marginLeft: '1rem'}}
        >
            {props.isRapidCreate ? <FlashOnOutlined/> : <AddOutlined/>}
        </IconButton>
        <Dialog open={open} onClose={handleClose} PaperProps={{ className: 'modal' }}>
            <DialogTitle className='primary-font'>Create Entry</DialogTitle>
            <DialogContent className='primary-font'>
                <DialogContentText className='primary-font'>
                    Provide an effective date and amount (with optional comments), then click Submit to create the
                    new entry.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Effective Date"
                    type="date"
                    fullWidth
                    variant="standard"
                    InputLabelProps={{shrink: true}}
                    value={entryDate}
                    onInput={(e) => setEntryDate(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="Amount"
                    type="number"
                    fullWidth
                    variant="standard"
                    value={entryAmount}
                    onInput={(e) => setEntryAmount(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="Comments"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={entryComments}
                    onInput={(e) => setEntryComments(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button className='modal-action-cancel' variant="text" onClick={handleClose}>Cancel</Button>
                <Button className='modal-action-submit' variant="contained" onClick={submitForm}>Submit</Button>
            </DialogActions>
        </Dialog>
    </div>);
}

export default CreateEntryDialog;
